// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message {
  display: flex;
  justify-content: center;
  text-align: center;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 8px 12px 8px 12px;
  border-radius: 5px;
  z-index: 100;
  font-weight: 500;
  width: auto;
  margin: auto auto 5px auto;
}

.messages {
  position: fixed;
  width: 100%;
  margin: auto;
  padding: auto;
  display: flex;
  justify-content: center;
  max-height: 120px;
  z-index: 2001;
  pointer-events: none;
}
.messages .messages-container {
  background-color: rgba(29, 15, 64, 0.1);
  border-radius: 4px;
  display: flex;
  justify-content: center;
  flex-direction: row;
  mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  pointer-events: all;
}
.messages .messages-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 100%);
  pointer-events: none;
}
.messages .messages-scroll-container {
  padding: 10px;
  max-height: 100%;
  overflow-y: scroll;
}
.messages .messages-scroll-container::-webkit-scrollbar {
  display: none;
}
.messages .close-btn {
  height: 25px;
  width: 25px;
}
.messages .close-btn:hover {
  cursor: pointer;
  transform: scale(1.1);
  background-color: white;
  border-radius: 4px;
}
.messages .close-btn:active {
  transform: scale(0.9);
}
.messages .success {
  background: rgba(142, 198, 63, 0.45);
  border-radius: 10px;
  color: #1d0f40;
}
.messages .error {
  background: rgba(255, 0, 0, 0.45);
  border-radius: 10px;
  color: #1d0f40;
}`, "",{"version":3,"sources":["webpack://./src/components/messages/messages.styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,0BAAA;AACF;;AAEA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,aAAA;EACA,oBAAA;AACF;AACE;EACE,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,mEAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;AACJ;AACI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,0FAAA;EAKA,oBAAA;AAHN;AAOE;EACE,aAAA;EACA,gBAAA;EACA,kBAAA;AALJ;AAMI;EACE,aAAA;AAJN;AAQE;EACE,YAAA;EACA,WAAA;AANJ;AAOI;EACE,eAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AALN;AAQI;EACE,qBAAA;AANN;AAUE;EACE,oCAAA;EACA,mBAAA;EACA,cAAA;AARJ;AAWE;EACE,iCAAA;EACA,mBAAA;EACA,cAAA;AATJ","sourcesContent":[".message {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  padding: 8px 12px 8px 12px;\n  border-radius: 5px;\n  z-index: 100;\n  font-weight: 500;\n  width: auto;\n  margin: auto auto 5px auto;\n}\n\n.messages {\n  position: fixed;\n  width: 100%;\n  margin: auto;\n  padding: auto;\n  display: flex;\n  justify-content: center;\n  max-height: 120px;\n  z-index: 2001;\n  pointer-events: none;\n\n  .messages-container {\n    background-color: rgba(29, 15, 64, 0.1);\n    border-radius: 4px;\n    display: flex;\n    justify-content: center;\n    flex-direction: row;\n    -webkit-mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(4px);\n    pointer-events: all;\n\n    &::before {\n      content: \"\";\n      position: absolute; // Changed from relative to absolute\n      top: 0;\n      left: 0;\n      height: 100%;\n      width: 100%;\n      background: linear-gradient(\n        to bottom,\n        rgba(255, 255, 255, 0) 0%,\n        rgba(255, 255, 255, 1) 100%\n      );\n      pointer-events: none; // This is to make sure that it doesn't block the interaction with child elements\n    }\n  }\n\n  .messages-scroll-container {\n    padding: 10px;\n    max-height: 100%;\n    overflow-y: scroll;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n\n  .close-btn {\n    height: 25px;\n    width: 25px;\n    &:hover {\n      cursor: pointer;\n      transform: scale(1.1);\n      background-color: white;\n      border-radius: 4px;\n    }\n\n    &:active {\n      transform: scale(0.9);\n    }\n  }\n\n  .success {\n    background: rgba(142, 198, 63, 0.45);\n    border-radius: 10px;\n    color: #1d0f40;\n  }\n\n  .error {\n    background: rgba(255, 0, 0, 0.45);\n    border-radius: 10px;\n    color: #1d0f40;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
